import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { Menu, message } from 'antd';
import { useStore } from '../../../common/stores';
import { ReloadIcon } from '../../icons';
import { IAppStoreBase, ISessionStoreBase } from '../../types';

const key = 're-run-analysis';

interface Props {
    appStore: IAppStoreBase;
    sessionStore: ISessionStoreBase;
    disabled?: boolean;
}

const ReRunAnalysisMenuItem: React.FC<Props> = ({ appStore, sessionStore, disabled }) => {
    const { tabsStore, restricedAccessStore } = useStore();

    if (restricedAccessStore.restricedModeEnabled || !appStore.isReloadable) {
        return null;
    }

    const onReload = async () => {
        const resp = await sessionStore.startSession(appStore.appId, appStore.packageId);

        if (!resp.isOk()) {
            message.error(resp.error.data ? resp.error.data.title : resp.error.text);
            return;
        }

        resp.map(({ sessionId }) =>
            tabsStore.setSessionTabReloading({
                sessionId,
                packageName: appStore.packageName,
                packageId: appStore.packageId
            })
        );

        sessionStore.updateSession(appStore.sessionId, 'Archived');
        appStore.dispose();
    };

    return (
        <Menu.Item
            key={key}
            eventKey={key}
            icon={<ReloadIcon color={disabled ? '#00000040' : undefined} />}
            onClick={onReload}
            disabled={disabled}
        >
            Re-run Analysis
        </Menu.Item>
    );
};

export default observer(ReRunAnalysisMenuItem);
